import getStore from '../store';
import type { AssetId } from 'owa-timestream-store';

export default function getSelectedAssets(): AssetId[] {
    return getStore().selectedAssets;
}
